export interface PaysafeTokenizationResponse {
  token: string;
}
